import http from '@util/http';
import { finance } from '@api/req';

/**
 * 开票
 */
export async function queryInvoiceList(params) {
  return http.get(finance.GET_INVOICE_LIST, params);
}

export async function queryInvoiceMyList(params) {
  return http.get(finance.GET_INVOICE_MY, params);
}

export async function queryMyInvoiceCheckList(params) {
  return http.get(finance.GET_INVOICE_CHECK, params);
}

export async function queryInvoiceOrgStatic(params) {
  return http.get(finance.GET_INVOICE_STATIC_ORG, params);
}

export async function queryInvoiceIncubatorStatic(params) {
  return http.get(finance.GET_INVOICE_STATIC_INCUBATOR, params);
}

export async function queryInvoiceOrgRecord(params) {
  return http.get(finance.GET_INVOICE_RECORD_ORG, params);
}

export async function queryInvoiceInfo(params) {
  return http.get(finance.GET_INVOICE_INFO, params);
}

export async function querySaveInvoice(params) {
  return http.post(finance.FINANCE_INVOICE_SAVE, params);
}

export async function queryDeleteInvoice(params) {
  return http.get(finance.FINANCE_INVOICE_DELETE, params);
}

export async function queryNextInvoice(params) {
  return params.uuid
    ? http.post(finance.FINANCE_INVOICE_NEXT, params)
    : http.get(finance.FINANCE_INVOICE_NEXT, params);
}

export async function queryReturnInvoice(params) {
  return http.post(finance.FINANCE_INVOICE_RETURN, params);
}

export async function queryCallbackInvoice(params) {
  return http.get(finance.FINANCE_INVOICE_CALLBACK, params);
}

export async function queryInvoiceWorkflow(params) {
  return http.get(finance.FINANCE_INVOICE_WORKFLOW, params);
}

export async function queryInvoiceInvalid(params) {
  return http.post(finance.FINANCE_INVOICE_INVALID, params);
}

export async function queryInvoiceWriteInfo(params) {
  return http.get(finance.GET_INVOICE_WRITE_INFO, params);
}

export async function querySaveWriteInvoice(params) {
  return http.post(finance.INVOICE_WRITE_SAVE, params);
}



// WEBPACK FOOTER //
// ./src/api/finance/invoice.js